"use strict";

exports.__esModule = true;
exports.default = void 0;

var _constants = require("../../utils/constants");

var builderOptions = [{
  component: _constants.CHOICE_TYPE,
  options: [{
    componentType: _constants.optionTypes.textInput,
    questionField: 'description',
    props: {
      label: 'Add supporting text to help colleagues answer this question?',
      placeholder: 'Enter additional text',
      maxLength: 550
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.multipleAnswers',
    label: 'Can colleagues select more than one option?',
    props: {
      label: 'Allow multiple answers'
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.required',
    label: 'Require this to be answered?',
    props: {
      label: 'Required'
    }
  }]
}, {
  component: _constants.TEXT_ANSWER_TYPE,
  options: [{
    componentType: _constants.optionTypes.textInput,
    questionField: 'description',
    props: {
      label: 'Add supporting text to help colleagues answer this question?',
      placeholder: 'Enter additional text',
      maxLength: 550
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.longerResponse',
    label: 'Allow a longer answer?',
    props: {
      label: 'Longer answer'
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.required',
    label: 'Require this to be answered?',
    props: {
      label: 'Required'
    }
  }]
}, {
  component: _constants.FILE_UPLOAD_TYPE,
  options: [{
    componentType: _constants.optionTypes.textInput,
    questionField: 'description',
    props: {
      label: 'Add supporting text to help colleagues answer this question?',
      placeholder: 'Enter additional text',
      maxLength: 550
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.acceptMultiple',
    label: 'Allow multiple images to be uploaded? (Max. 5)',
    props: {
      label: 'Allow multiple'
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.required',
    label: 'Require this to be answered?',
    props: {
      label: 'Required'
    }
  }]
}, {
  component: _constants.RATING_TYPE,
  options: [{
    componentType: _constants.optionTypes.textInput,
    questionField: 'description',
    props: {
      label: 'Add supporting text to help colleagues answer this question?',
      placeholder: 'Enter additional text',
      maxLength: 550
    }
  }, {
    componentType: _constants.optionTypes.radioButton,
    questionField: 'component.props.ratingOptions',
    label: 'Number of rating options',
    forceBranchingCleanup: true,
    props: {
      options: [{
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      }]
    }
  }, {
    componentType: _constants.optionTypes.checkbox,
    questionField: 'component.props.required',
    label: 'Require this to be answered?',
    props: {
      label: 'Required'
    }
  }]
}];
var _default = builderOptions;
exports.default = _default;